import { get, patch } from './requests'
import moment from 'moment'

export const getNotificationsByUserId = key => get(['notifications'], { key })
export const readNotificationsById = (key, notificationId) =>
  patch(['notifications', notificationId], { key }, { datetime_reading: moment().toISOString() })
